import { BsArrowUpRight } from 'react-icons/bs';
import { StyledButton, Type } from './Button.style'

interface Props {
    btnText: string,
    btnLink: string,
    btnType: Type,
    isDisabled: boolean,
    isDynamicBtn?: boolean,
}

const Button: React.FC<Props> = ({btnText, btnLink, btnType = 'secondary', isDisabled = false, isDynamicBtn = false }) => {
    return (
       <StyledButton href={btnLink} type={btnType} isDisabled={isDisabled} isDynamicBtn={isDynamicBtn} {...btnType === 'external' ? {target:'_blank'}: ''}>
            {btnText}{btnType==='external' ? <BsArrowUpRight/> : ''}
        </StyledButton>
    );
};

export default Button;